/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A feature on the parent sequence
 * @export
 * @interface SequenceFeature
 */
export interface SequenceFeature {
    /**
     * 
     * @type {number}
     * @memberof SequenceFeature
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SequenceFeature
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SequenceFeature
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof SequenceFeature
     */
    start: number;
    /**
     * 
     * @type {number}
     * @memberof SequenceFeature
     */
    stop: number;
    /**
     * 
     * @type {boolean}
     * @memberof SequenceFeature
     */
    directStrand: boolean;
    /**
     * 
     * @type {number}
     * @memberof SequenceFeature
     */
    score?: number;
    /**
     * 
     * @type {string}
     * @memberof SequenceFeature
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof SequenceFeature
     */
    typeId?: number;
    /**
     * 
     * @type {string}
     * @memberof SequenceFeature
     */
    typeKey?: string;
    /**
     * 
     * @type {string}
     * @memberof SequenceFeature
     */
    forceColor?: string;
}

/**
 * Check if a given object implements the SequenceFeature interface.
 */
export function instanceOfSequenceFeature(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "start" in value;
    isInstance = isInstance && "stop" in value;
    isInstance = isInstance && "directStrand" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function SequenceFeatureFromJSON(json: any): SequenceFeature {
    return SequenceFeatureFromJSONTyped(json, false);
}

export function SequenceFeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): SequenceFeature {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'start': json['start'],
        'stop': json['stop'],
        'directStrand': json['directStrand'],
        'score': !exists(json, 'score') ? undefined : json['score'],
        'type': json['type'],
        'typeId': !exists(json, 'typeId') ? undefined : json['typeId'],
        'typeKey': !exists(json, 'typeKey') ? undefined : json['typeKey'],
        'forceColor': !exists(json, 'forceColor') ? undefined : json['forceColor'],
    };
}

export function SequenceFeatureToJSON(value?: SequenceFeature | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'start': value.start,
        'stop': value.stop,
        'directStrand': value.directStrand,
        'score': value.score,
        'type': value.type,
        'typeId': value.typeId,
        'typeKey': value.typeKey,
        'forceColor': value.forceColor,
    };
}

